import React from 'react';
import { Card } from 'reactstrap';
import { HashLink } from 'react-router-hash-link';
import ControlPanelIcon from 'components/atoms/icons/controlPanelIcon';
import GraphsIcon from 'components/atoms/icons/graphsIcon';
import MedicationIcon from 'components/atoms/icons/medicationIcon';
import UserProfileIcon from 'components/atoms/icons/userProfileIcon';
import ActivityIcon from 'components/atoms/icons/activityIcon';
import PropTypes from 'prop-types';

const MiniNav = ({ charts }) => {
  const hasDiagnosis = Object.entries(charts).some(
    ([, data]) => data.length > 0,
  );
  return (
    <Card className="mini-nav">
      <HashLink smooth to="#control-panel">
        <div className="mini-nav__item">
          <ControlPanelIcon />
          <span className="mini-nav__item-title">Control Panel</span>
        </div>
      </HashLink>
      {hasDiagnosis && (
        <HashLink smooth to="#graphs">
          <div className="mini-nav__item">
            <GraphsIcon />
            <span className="mini-nav__item-title">Graphs</span>
          </div>
        </HashLink>
      )}
      <HashLink smooth to="#activity">
        <div className="mini-nav__item">
          <ActivityIcon />
          <span className="mini-nav__item-title">Activity</span>
        </div>
      </HashLink>
      <HashLink smooth to="#medication">
        <div className="mini-nav__item">
          <MedicationIcon />
          <span className="mini-nav__item-title">Medication</span>
        </div>
      </HashLink>
      <HashLink smooth to="#user-profile">
        <div className="mini-nav__item">
          <UserProfileIcon />
          <span className="mini-nav__item-title">Patient Profile</span>
        </div>
      </HashLink>
    </Card>
  );
};

MiniNav.propTypes = {
  charts: PropTypes.object,
};

export default MiniNav;
